import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Resultbob() {
  return (
    <section className="result_bob text_white" style={{ background: "#000" }}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>The Results</h2>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <p>
              Our expertise and experience enabled us to successfully complete
              the project and meet all the client’s expectations regarding the
              B.O.B application. By the end of the development and designing
              process, the B.O.B app managed to deliver a seamless and robust
              user-experience to the customers by listing several businesses
              quickly and efficiently. The users could get more information and
              search for a specific company by leveraging the filter and search
              functionality. They could also explore the product or
              service-based business world around them.
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <div className="result_img mt-4">
              <StaticImage
                src="../../../images/case-studies/bob/result_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1050}
                height={796}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultbob;
